module.exports = __webpack_public_path__ + "media/common/icon_pen-e333e24c.svg";